import { create } from "zustand";
import type { SyncJob } from "../lib/api";

interface SyncState {
  activeJob: SyncJob | null;
  lastCompletedJob: SyncJob | null;
  /** Watchdog hat den Sync Worker per SIGSTOP pausiert (Systemlast). */
  workerPaused: boolean;
  /** Distinguishes an authoritative empty result from startup/poll failures. */
  statusPhase: "loading" | "ready" | "error";
  setActiveJob: (job: SyncJob | null) => void;
  setLastCompletedJob: (job: SyncJob | null) => void;
  setWorkerPaused: (paused: boolean) => void;
  setStatusPhase: (phase: SyncState["statusPhase"]) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  activeJob: null,
  lastCompletedJob: null,
  workerPaused: false,
  statusPhase: "loading",
  setActiveJob: (job) => set({ activeJob: job }),
  setLastCompletedJob: (job) => set({ lastCompletedJob: job }),
  setWorkerPaused: (paused) => set({ workerPaused: paused }),
  setStatusPhase: (statusPhase) => set({ statusPhase }),
}));
